import Camera from './Camera.js';
import SketchfabWrapper from './SketchfabWrapper.js';

var ModelPicker = {

    SetPanoMaterialCallback: function(){
        
        //get the matrix of the pano sphere
        var arrPanoSphere = []
        SketchfabWrapper.getNodeFromGraphByName(SketchfabWrapper.sceneGraph,app.config.panoobject,'MatrixTransform',arrPanoSphere);
        
        
        if (arrPanoSphere.length > 0){
            //going into pano mode, remove the camera restrictions
            clearInterval(Camera.loopTimeoutIndex)
            
            //where's the pano sphere?
            var lookat = [arrPanoSphere[0].worldMatrix[12], arrPanoSphere[0].worldMatrix[13], arrPanoSphere[0].worldMatrix[14]]
            var eye    = [lookat[0] + 5, lookat[1], lookat[2]]

            //set up new camera restrictions
            SketchfabWrapper.api.setCameraLookAt(eye, lookat, 0, function () {
                
                //initialize the new camera behavior
                Camera.inPano       = true;
                Camera.panoLookat   = lookat;
                Camera.panoDistance = 5;
                Camera.cameraLoopPano();
                SketchfabWrapper.api.setFov(60,function(err,angle){
                    console.log('err',err);
                    console.log('angle',angle);
                });

                window.app.onEnterPanorama();
                
                //show the pano sphere
                SketchfabWrapper.SetObjectVisibility(app.config.panoobject,true,true)
            });
        }
        
        //get rid of the loading message
        app.onPanoramaLoadEnd();
    },

    enterPanoMode: function(panoName,clickedId){
        app.onPanoramaLoadStart();

        //hide the building
        for (var n = 0; n < app.config.levels.length; n++)  {
          SketchfabWrapper.SetObjectVisibility(app.config.levels[n]['3dname'], false, true);
        };
        
        //let's see if we already have this pano imported. If so, we can reuse it
        if (app.config.panos[panoName].hasOwnProperty("uid")){
            ModelPicker.setFlatMaterial(app.config.panomaterial,app.config.panos[panoName].uid,ModelPicker.SetPanoMaterialCallback)
        }else{
            //apply the pano texture to the panosphere
            var url = app.config.panos[panoName]['url']
            
            //add the texture for the pano
            SketchfabWrapper.api.addTexture(url,function(err,textureUid){
                if (textureUid !== undefined){
                    //cache that id
                    app.config.panos[panoName].uid = textureUid
                    
                    ModelPicker.setFlatMaterial(app.config.panomaterial,textureUid,ModelPicker.SetPanoMaterialCallback)
                };
            });
        }
    },
    
    setFlatMaterial: function(materialName,textureUid,callback){
        //find the material of the panosphere so we can update it
        SketchfabWrapper.api.getMaterialList( function( err, materials ) {
            for (var n = 0;n<materials.length;n++){
                if (materials[n].name === materialName){

                    //get rid of the diffuse
                    var materialToUpdate = materials[n];
                    materialToUpdate.channels['Opacity'].factor = 1.0; //the pano starts out transparent. Make it opaque here
                    materialToUpdate.channels['DiffusePBR'].factor = 0;
                    materialToUpdate.channels['AlbedoPBR'].factor = 0;
                    
                    //set up the emit for a nice flat look
                    ModelPicker.SetEmitTexture(materialToUpdate,textureUid,0.9);

                    //Apply the change
                    SketchfabWrapper.api.setMaterial( materialToUpdate, function() {
                        console.log( 'Material updated' );
                        callback();
                    });
                }
            }
        });
    },
    
    SetEmitTexture: function(theMaterial, textureUid, theFactor){
        var myTexture = SketchfabWrapper.MakeTexture(textureUid)
        theMaterial.channels['EmitColor'].enable = true
        theMaterial.channels['EmitColor'].texture = myTexture
        theMaterial.channels['EmitColor'].factor = theFactor
        delete theMaterial.channels['EmitColor'].color //delete the color value, otherwise the material is invalid
    },
    
    EnterOrbitMode: function(){
        let theView = app.config.views['start'];
        SketchfabWrapper.SetView(theView.eye,theView.lookat,0);
        SketchfabWrapper.api.setFov(45,function(){});
        Camera.cameraLoopOrbit();
        
        // bring back the buildings
        app.setLevel(app.activeLevel);
    },
    
    ExitPanoMode: function(){
        //change the camera loop
        Camera.inPano = false;
        clearInterval(Camera.loopTimeoutIndex);
        
        //hide the pano sphere
        SketchfabWrapper.SetObjectVisibility(app.config.panoobject,false,true)
    },

    ClickCallback: function(clickEvent) {
        if (Camera.inPano === false){
            var theName = SketchfabWrapper.getNodeNameById(clickEvent.instanceID)
            
            if (app.config.panos.hasOwnProperty(theName)) {
                ModelPicker.enterPanoMode(theName,clickEvent.instanceID);
            }            
        };
    }
};

export default ModelPicker;


// WEBPACK FOOTER //
// ./src/js/lib/ModelPicker.js